// Keep in sync with ProfitabilityDocument::ALLOWED_EXTENSIONS (api).
export const ACCEPTED_EXTENSIONS = [
  ".pdf",
  ".docx",
  ".pptx",
  ".xlsx",
  ".xlsm",
  ".csv",
  ".tsv",
  ".txt",
  ".md",
  ".json",
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".webp",
  ".tif",
  ".tiff",
] as const;

export const ACCEPTED_FILE_TYPES = ACCEPTED_EXTENSIONS.join(",");

export const MAX_DOCUMENT_BYTES = 25 * 1024 * 1024;
export const MAX_DOCUMENTS_PER_REPORT = 20;

export const DOCUMENT_POLL_INTERVAL_MS = 2_000;

export const DOCUMENT_STATUS = {
  pending: "pending",
  ready: "ready",
  failed: "failed",
} as const;

export type DocumentStatus =
  (typeof DOCUMENT_STATUS)[keyof typeof DOCUMENT_STATUS];
